export const WIRE_CONTAINER_TAG_NAME = 'wire-container';
